// extracted by mini-css-extract-plugin
export default {"TableRow":"Fattura_TableRow__20nxy"};